"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeParse = exports.safeStringify = void 0;
function safeStringify(arg) {
    if (arg) {
        if (typeof arg === "string" || arg instanceof String) {
            return arg.toString();
        }
        else {
            try {
                return JSON.stringify(arg);
            }
            catch (_) {
                return "";
            }
        }
    }
    else {
        return "";
    }
}
exports.safeStringify = safeStringify;
function safeParse(data) {
    if (typeof data === "string") {
        try {
            return JSON.parse(data);
        }
        catch (_e) {
            return data;
        }
    }
    else
        return data;
}
exports.safeParse = safeParse;
//# sourceMappingURL=json-helpers.js.map